import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { UP_TO_TRILLION } from '../../../../vars';

const DollarAmountFormat = React.forwardRef((props, ref) => {
  const { onChange, name, maxValue, ...other } = props;

  const setRef = React.useCallback(
    (maskedInputRef) => {
      const value = maskedInputRef ? maskedInputRef.inputElement : null;

      if (typeof ref === 'function') {
        ref(value);
      } else if (ref) {
        ref.current = value;
      }
    },
    [ref],
  );

  return (
    <NumberFormat
      {...other}
      getInputRef={setRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      allowNegative={false}
      isNumericString
      decimalScale={2}
      prefix="$"
      isAllowed={(values) => {
        const { floatValue } = values;
        return floatValue <= (props.maxValue ?? UP_TO_TRILLION) || isNaN(floatValue);
      }}
    />
  );
});

DollarAmountFormat.propTypes = {
  name: PropTypes.string,
  maxValue: PropTypes.number,
  onChange: PropTypes.func.isRequired
};

export default DollarAmountFormat;